import { HttpClient, HttpResponse } from '@angular/common/http';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { CampuscctvserviceService } from '../service/campuscctvservice.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-state',
  templateUrl: './state.component.html',
  styleUrls: ['./state.component.scss']
})
export class StateComponent {
  total: any;
  @Input() id:any;
  @Output() buttonWasClicked = new EventEmitter<any>();
  searchkey: any;
  
  constructor(public campuscctvserviceservice:CampuscctvserviceService,private spinner: NgxSpinnerService ) {}
  ngOnInit(): void {
    const id =this.id
    this.spinner.show();
    this.campuscctvserviceservice.getOverAllCities().subscribe(
      {
        next:(HttpResponse:any)=>{
          this.total=HttpResponse;
          console.log('Citydetails',this.total);
          this.spinner.hide();
        },
        error:(err:any)=>{
          console.log('Error',err);
          this.spinner.hide();
        },
        complete:()=>{
          console.log('completed!');
        }
      }
    );
    this.campuscctvserviceservice.search.subscribe((val:any)=>{
      this.searchkey=val;
    }) 
  }

  onButtonClick(data:any) {
    this.buttonWasClicked.emit(data);
}
}
